// Core React imports
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Application imports
import AppRoutes from "./routes/AppRoutes.js";

// Styles and configuration
import "./styles/index.css";
import "./config/sentry.js";
import * as Sentry from "@sentry/react";

const root = ReactDOM.createRoot(document.getElementById("root"), {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <BrowserRouter>
    <AppRoutes />
  </BrowserRouter>
);
